<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 256 256"
         style="enable-background:new 0 0 512 512" xml:space="preserve">
        <circle r="128" cx="128" cy="128" fill="currentColor" shape="circle"></circle>
    </svg>
</template>
